import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  sideBar: true,
  page: "",
  parentPage: "",
  academicSession: {},
  asCheck: false,
};

const compsSlice = createSlice({
  name: "comps",
  initialState,
  reducers: {
    ChangeSideBar: (state) => {
      state.sideBar = !state.sideBar;
    },
    ChangeCurrentPage: (state, action) => {
      state.page = action.payload;
    },
    ChangeParentPage: (state, action) => {
      state.parentPage = action.payload;
    },
    ChangeAcademicSession: (state, action) => {
      state.academicSession = action.payload;
    },
    ChangeASCheck: (state, action) => {
      state.asCheck = action.payload;
    },
    ResetComp: (state) => {
      state.sideBar = initialState.sideBar;
      state.page = initialState.page;
      state.parentPage = initialState.parentPage;
      state.academicSession = initialState.academicSession;
      state.asCheck = initialState.asCheck;
    },
  },
});

export default compsSlice.reducer;
export const {
  ChangeSideBar,
  ChangeCurrentPage,
  ChangeParentPage,
  ChangeAcademicSession,
  ChangeASCheck,
  ResetComp,
} = compsSlice.actions;
